/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}                 from '@/util/i.command';
import {
  Diversion
} from '@/models/scenario/diversion';
import {DiversionChange}          from '@/screens/ide/diversion/diversion.change';
import {DiversionEditorComponent} from '@/components/diversion.editor.component';
import {Logger}                   from '@/util/logger';
import {TrackIngress} from "@/helpers/track.ingress";

/**
 *
 * @class AddDiversionCommand
 *
 * @brief reversible addition of a diversion
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class AddDiversionCommand implements ICommand {

  private readonly newValue: DiversionChange = null;
  private   editor: DiversionEditorComponent = null;
  private   newDiv: Diversion                = null;

    constructor(newValue: DiversionChange, editor: DiversionEditorComponent) {

    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    /* assign id/create the new diversion */

    if (this.newDiv == null) {

      const input: DiversionChange = this.newValue.snapshot;
      const    id: number          = this.editor.scenario.allocateDiversionId();

      this.newDiv                  = new Diversion(
        id,
        input.start,
        input.startTrack.track,
        input.end,
        input.endTrack.track,
        input.trains,
        input.duration,
        input.stdDev,
        input.type,
        input.work,
        input.name,
        input.description,
        -1
      );
    }

    Logger.debug('[diversion/table:add] saving ', this.newDiv);

    /* save it to the scenario */

    this.editor.scenario.diversions().set(this.newDiv._id, this.newDiv);

    /* refresh the views */

    this.editor.table.refreshTable();

    Logger.debug('[diversion/table:add] refreshed.');

    /* clear the view selections */

    this.editor.table.doSelection(null);
    this.editor.editor.clear();

    Logger.debug('[diversion/table:add] selection cleared.');
  }

  /** reverse the command's effects */
  unExecute() {

    /* delete the block that was added */

    Logger.debug('[diversion/table:add] deleting ', this.newDiv);

    this.editor.scenario.diversions().delete(this.newDiv._id);

    /* refresh the views (so the block disappears) */

    this.editor.table.refreshTable();

    Logger.debug('[diversion/table:add] refreshed.');

    /*
     * (re)select what was selected when we added, this brings back the
     * selection, and the the edit inputs as they were just before the
     * add.
     *
     */

    this.editor.table.doSelection(this.newValue);

  }

  /** return a string summary of this command */
  asString(): string {

    const b = (this.newValue instanceof DiversionChange) ? this.newDiv._id : '';

    return '[diversion/table:add] ' + b;
  }

}
